
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundLow as ObiSoundLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-low.js';
 
 
 

 
 export const ObiSoundLow = createComponent({
   react: React,
   tagName: 'obi-sound-low',
   elementClass: ObiSoundLowElement,
   events: {
     
   }
  });
 
 